import React from 'react';

import { useIntl } from '../../../../util/reactIntl';
import { Button, NamedLink } from '../../../../components';

import logoBlack from '../../../../assets/logo-black.png';
import SearchIcon from '../SearchIcon';
import TopbarProfileMenu from '../TopbarProfileMenu/TopbarProfileMenu';

import css from './TopbarMobileMenuHeader.module.css';

const MenuCloseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M6 6L18 18M6 18L18 6"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const NotificationBellIcon = () => (
  <svg
    className={css.bellIcon}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M10.2673 20.9998C10.4428 21.3038 10.6953 21.5563 10.9993 21.7318C11.3033 21.9073 11.6482 21.9997 11.9993 21.9997C12.3503 21.9997 12.6952 21.9073 12.9992 21.7318C13.3033 21.5563 13.5557 21.3038 13.7313 20.9998M11.6793 2.00879C10.1456 2.0907 8.7018 2.7576 7.64512 3.87213C6.58844 4.98666 5.99939 6.46397 5.99927 7.99979C5.99927 12.4988 4.58827 13.9558 3.26127 15.3258C3.13063 15.469 3.04442 15.647 3.01312 15.8383C2.98183 16.0296 3.00679 16.2258 3.08498 16.4032C3.16316 16.5805 3.2912 16.7313 3.45352 16.8373C3.61585 16.9432 3.80545 16.9996 3.99927 16.9998H19.9993C20.1931 16.9999 20.3827 16.9436 20.5451 16.8379C20.7076 16.7322 20.8358 16.5815 20.9142 16.4043C20.9926 16.2271 21.0178 16.0309 20.9867 15.8396C20.9557 15.6483 20.8697 15.4701 20.7393 15.3268C19.9153 14.4768 19.0613 13.5958 18.5293 11.9788"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 8C19.6569 8 21 6.65685 21 5C21 3.34315 19.6569 2 18 2C16.3431 2 15 3.34315 15 5C15 6.65685 16.3431 8 18 8Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * Top bar shown at the top of the mobile menu modal (matches main mobile header).
 *
 * @component
 */
const TopbarMobileMenuHeader = props => {
  const {
    isAuthenticated,
    currentUser,
    currentPage,
    notificationCount = 0,
    inboxTab,
    showSearchForm,
    showCreateListingsLink,
    onCloseMenu,
    onOpenSearch,
    onLogout,
    menuCloseButtonId,
  } = props;

  const intl = useIntl();
  const notificationDot = notificationCount > 0 ? <span className={css.notificationDot} /> : null;

  const searchButtonMaybe =
    isAuthenticated && showSearchForm ? (
      <Button
        rootClassName={css.iconButton}
        onClick={() => {
          onCloseMenu();
          onOpenSearch?.();
        }}
        title={intl.formatMessage({ id: 'Topbar.searchIcon' })}
      >
        <SearchIcon
          rootClassName={css.searchIcon}
          ariaLabel={intl.formatMessage({ id: 'Topbar.searchIcon' })}
        />
      </Button>
    ) : null;

  const inboxLinkMaybe = isAuthenticated ? (
    <NamedLink
      className={css.iconButton}
      name="InboxPage"
      params={{ tab: inboxTab }}
      onClick={onCloseMenu}
      title={intl.formatMessage({ id: 'TopbarDesktop.inbox' })}
    >
      <NotificationBellIcon />
      {notificationDot}
    </NamedLink>
  ) : null;

  const profileMenuMaybe = isAuthenticated ? (
    <TopbarProfileMenu
      isMobile
      isModalHeader
      menuLabelId="profile-menu-label-mobile-modal"
      currentPage={currentPage}
      currentUser={currentUser}
      onLogout={onLogout}
      showManageListingsLink={showCreateListingsLink}
      intl={intl}
      className={css.profileMenu}
    />
  ) : null;

  return (
    <header className={css.root}>
      <div className={css.left}>
        <Button
          id={menuCloseButtonId}
          rootClassName={css.menuCloseButton}
          onClick={onCloseMenu}
          title={intl.formatMessage({ id: 'Topbar.menuIcon' })}
        >
          <MenuCloseIcon />
        </Button>
        <NamedLink className={css.logoLink} name="LandingPage" onClick={onCloseMenu}>
          <img src={logoBlack} className={css.logo} alt={intl.formatMessage({ id: 'Topbar.logoIcon' })} />
        </NamedLink>
      </div>
      <div className={css.right}>
        {searchButtonMaybe}
        {inboxLinkMaybe}
        {profileMenuMaybe}
      </div>
    </header>
  );
};

export default TopbarMobileMenuHeader;
